class SomethingMoreBespokeModalController {
    constructor(options = {}) {
        //options
        this.triggerAttr = options.triggerAttr || "data-open-bespoke-modal";
        this.formModalId = options.formModalId || "something-more-bespoke";
        this.successModalId = options.successModalId || "something-more-bespoke-thank-you";

        this.addEventListeners();
    }
  
    addEventListeners() {
        const openTriggers = document.querySelectorAll(`[${this.triggerAttr}]`);
        const closeFormModalButton = document.querySelector(".something-more-bespoke--modal-container .modal .close-button");
        const closeSuccessModalButton = document.querySelector(".something-more-bespoke-thank-you--modal-container .modal .close-button");
        const form = document.querySelector('.something-more-bespoke--modal-container .modal form[action="/contact#contact_form"]');
        const asapCheckbox = form.querySelector('input[name="contact[date-occasion-asap]"]');

        //binds event listeners
        closeFormModalButton.addEventListener('click', e => { this.handleCloseFormModal(e) });
        closeSuccessModalButton.addEventListener('click', e => { this.handleCloseSuccessModal(e) });
        form.addEventListener('submit', e => { this.handleSubmit(e) });
        asapCheckbox.addEventListener('change', e => { this.handleASAPChange(e) });

        if( openTriggers ){
            openTriggers.forEach((el) => {
                el.addEventListener("click", () => { window.modalController.presentModal(this.formModalId) });
            });
        }
    }

    handleCloseFormModal(e) {
        e.preventDefault()

        const formErrors = document.querySelector(".something-more-bespoke--modal-container .modal .form-errors")
        if( formErrors ) {
            formErrors.style.display = none;
        }

        window.modalController.hideModal(this.formModalId);
    }

    handleCloseSuccessModal(e) {
        e.preventDefault()
        window.modalController.hideModal(this.successModalId);
    }

    handleASAPChange(e) {
        const dateOfOccasionInput = document.querySelector('.something-more-bespoke--modal-container .modal .form input#date-occasion');
        dateOfOccasionInput.disabled = e.target.checked;
    }

    handleSubmit(e) {
        console.log(e);
    }

    handleFormErrors(){
        window.modalController.presentModal(this.formModalId);
    }

    handleFormSuccess(){
        window.modalController.presentModal(this.successModalId);
    }
}

window.SomethingMoreBespokeModalController = new SomethingMoreBespokeModalController()